<div class="flex flex-col w-full h-full bg-[var(--app-base)]">
  <div class="flex items-center gap-1.5 flex-wrap px-4 py-3 bg-white border-b border-[var(--app-border)] shrink-0">
    <button type="button" (click)="setTool('draw')"
      [class.bg-[var(--primary-dark)]]="tool() === 'draw'" [class.text-white]="tool() === 'draw'"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium border border-[var(--app-border)] flex items-center gap-1 transition">
      <span class="material-icons text-[15px]">edit</span> Draw
    </button>
    <button type="button" (click)="setTool('text')"
      [class.bg-[var(--primary-dark)]]="tool() === 'text'" [class.text-white]="tool() === 'text'"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium border border-[var(--app-border)] flex items-center gap-1 transition">
      <span class="material-icons text-[15px]">title</span> Text
    </button>
    <button type="button" (click)="setTool('redact')"
      [class.bg-[var(--primary-dark)]]="tool() === 'redact'" [class.text-white]="tool() === 'redact'"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium border border-[var(--app-border)] flex items-center gap-1 transition">
      <span class="material-icons text-[15px]">visibility_off</span> Hide
    </button>

    <span class="text-[12px] text-[var(--tertiary-text)] ml-3 hidden sm:inline">
      <ng-container [ngSwitch]="tool()">
        <ng-container *ngSwitchCase="'draw'">Drag on the image to draw.</ng-container>
        <ng-container *ngSwitchCase="'text'">Click where you want a note, then type and press Enter.</ng-container>
        <ng-container *ngSwitchDefault>Drag over anything private. It is removed from the image, not covered.</ng-container>
      </ng-container>
    </span>

    <button type="button" (click)="undo()" [disabled]="annotations().length === 0"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] disabled:opacity-40 transition ml-auto">
      Undo
    </button>
    <button type="button" (click)="clear()" [disabled]="annotations().length === 0"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] disabled:opacity-40 transition">
      Clear all
    </button>

    <span class="w-px h-6 bg-[var(--app-border)] mx-1"></span>

    <button type="button" (click)="cancel()"
      class="py-1.5 px-3 rounded-lg text-[12px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">
      Cancel
    </button>
    <button type="button" (click)="save()"
      class="py-1.5 px-4 rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white hover:opacity-90 transition">
      Save
    </button>
  </div>

  <!--
    The image sizes itself with max-w/max-h and auto width and height, never object-contain.
    Pointer positions are converted to image pixels through this element's bounding box, so
    letterboxing it would silently misplace every annotation.

    draggable="false" matters: without it the browser's native image drag starts on pointerdown and
    the user drags a ghost of the screenshot around instead of drawing on it.
  -->
  <div class="flex-1 min-h-0 overflow-auto flex items-center justify-center p-4">
    <div class="relative inline-block select-none leading-none">
      <img #previewimg [src]="preview()" alt="Screenshot being annotated" draggable="false"
        class="max-w-full max-h-full w-auto h-auto block select-none touch-none shadow-lg bg-white"
        [class.cursor-crosshair]="tool() !== 'text'"
        [class.cursor-text]="tool() === 'text'"
        (dragstart)="$event.preventDefault()"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)" />

      <input *ngIf="textAt() as at" cdkFocusInitial
        [value]="textValue()"
        (input)="textValue.set($any($event.target).value)"
        (keydown.enter)="commitText()"
        (keydown.escape)="cancelText()"
        (blur)="commitText()"
        placeholder="Type, then press Enter"
        class="absolute text-[13px] px-1.5 py-0.5 rounded border-2 border-[#E5343D] bg-white/95 outline-none min-w-[180px] z-10"
        [style.left.%]="at.x / width * 100"
        [style.top.%]="at.y / height * 100" />
    </div>
  </div>
</div>
